import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

const CLASS_STYLES = [
  {
    badge: 'border-blue-400/50 bg-blue-500/15 text-blue-100',
    accent: 'border-l-blue-400 bg-blue-500/5',
  },
  {
    badge: 'border-emerald-400/50 bg-emerald-500/15 text-emerald-100',
    accent: 'border-l-emerald-400 bg-emerald-500/5',
  },
  {
    badge: 'border-amber-400/50 bg-amber-500/15 text-amber-100',
    accent: 'border-l-amber-400 bg-amber-500/5',
  },
  {
    badge: 'border-fuchsia-400/50 bg-fuchsia-500/15 text-fuchsia-100',
    accent: 'border-l-fuchsia-400 bg-fuchsia-500/5',
  },
  {
    badge: 'border-cyan-400/50 bg-cyan-500/15 text-cyan-100',
    accent: 'border-l-cyan-400 bg-cyan-500/5',
  },
]

function getStyleIndex(id) {
  if (!id) return null

  const hash = Array.from(id).reduce(
    (total, character) => total + character.charCodeAt(0),
    0,
  )

  return hash % CLASS_STYLES.length
}

function getBadgeStyle(id) {
  const styleIndex = getStyleIndex(id)

  return styleIndex == null
    ? 'border-neutral-blue-500 bg-neutral-blue-700 text-shades-0'
    : CLASS_STYLES[styleIndex].badge
}

export function getCarClassAccentClass(id) {
  const styleIndex = getStyleIndex(id)

  return styleIndex == null
    ? 'border-l-neutral-blue-500 bg-neutral-blue-800/40'
    : CLASS_STYLES[styleIndex].accent
}

export function CarClassBadge({ carClass, className = '' }) {
  return (
    <Badge
      variant="outline"
      className={`${getBadgeStyle(carClass?.id)} ${className}`}
    >
      {carClass?.name || 'Unclassified'}
    </Badge>
  )
}

export function CarClassHeading({ carClass, className }) {
  return (
    <div
      className={cn(
        'flex w-fit items-center rounded-full bg-shades-0 px-4 py-1 text-neutral-blue-900',
        className,
      )}
    >
      <span className="text-sm font-semibold">
        {carClass?.name || 'Unclassified'}
      </span>
    </div>
  )
}
